import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { scheduledLessonQueries } from '@/data/query-keys/scheduledLessonQueryKey';

type UseNextScheduledLessonParams = {
  klassId?: number;
};

const MAX_RETRIES = 3;

const isNotFound = (error: unknown) =>
  isAxiosError(error) && error.response?.status === 404;

export default function useNextScheduledLesson({
  klassId,
}: UseNextScheduledLessonParams) {
  const {
    data: nextLesson,
    isInitialLoading,
    error,
  } = useQuery({
    ...scheduledLessonQueries.next(klassId ?? 0),
    enabled: !!klassId,
    staleTime: REQUEST_STALE_TIME_IN_MS,
    retry: (failureCount, retryError) =>
      !isNotFound(retryError) && failureCount < MAX_RETRIES,
  });

  return {
    nextLesson,
    isLoading: isInitialLoading,
    error: isNotFound(error) ? null : error,
  };
}
